module.exports = __webpack_public_path__ + "static/media/Favourite_active.a76ab0cc.svg";